exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-page-jsx": () => import("./../../../src/templates/page.jsx" /* webpackChunkName: "component---src-templates-page-jsx" */),
  "component---src-templates-post-corporate-blog-jsx": () => import("./../../../src/templates/postCorporateBlog.jsx" /* webpackChunkName: "component---src-templates-post-corporate-blog-jsx" */),
  "component---src-templates-post-resources-jsx": () => import("./../../../src/templates/postResources.jsx" /* webpackChunkName: "component---src-templates-post-resources-jsx" */)
}

